import { render, staticRenderFns } from "./BackVlog.vue?vue&type=template&id=bb9b8804&scoped=true"
import script from "./BackVlog.vue?vue&type=script&lang=js"
export * from "./BackVlog.vue?vue&type=script&lang=js"
import style0 from "./BackVlog.vue?vue&type=style&index=0&id=bb9b8804&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9b8804",
  null
  
)

export default component.exports